"use client";
import type { ReactElement } from "react";
import { motion } from "framer-motion";
import { Ccontainer } from "@/components/ui/Ccontainer";
import { Ctext } from "@/components/ui/Ctext";
import { ColorType, FontWeight, RadiusSize } from "@/theme";
import { CWITNESS_HERO_HOVER_VARIANT } from "./constants";
import { resolveHeroPresentation } from "./selectors";
import { buildHeroContainerStyle, buildHeroContentWrapperStyle, buildHeroGlowStyle, buildHeroSubtitleStyle, buildHeroTitleStyle, buildHeroWrapperStyle, } from "./styles";
interface CwitnessHeroCardProps {
    isCompact: boolean;
    isMobile: boolean;
}
export function CwitnessHeroCard({ isCompact, isMobile, }: CwitnessHeroCardProps): ReactElement {
    const heroPresentation = resolveHeroPresentation({ isMobile });
    const heroContainerStyle = buildHeroContainerStyle({ isMobile });
    const heroGlowStyle = buildHeroGlowStyle({ isMobile });
    const heroWrapperStyle = buildHeroWrapperStyle({ isMobile });
    const heroTitleStyle = buildHeroTitleStyle({ isCompact, isMobile });
    const heroSubtitleStyle = buildHeroSubtitleStyle({ isCompact, isMobile });
    const heroContentWrapperStyle = buildHeroContentWrapperStyle({ isMobile });
    return (
      <motion.div style={heroWrapperStyle} whileHover={CWITNESS_HERO_HOVER_VARIANT} initial="idle">
        <Ccontainer borderGradient={{
            angle: 165,
            colors: [
                { color: "#ffffff", opacity: 0.07, stop: 0 },
                { color: "#ffffff", opacity: 0, stop: 40 },
                { color: "#ffffff", opacity: 0, stop: 50 },
                { color: "#0ac5b2", opacity: 0.04, stop: 90 },
            ],
        }} radius={RadiusSize.Large} contentWrapperStyle={heroContentWrapperStyle} display="flex" flexDirection={heroPresentation.flexDirection} justifyContent={heroPresentation.justifyContent} alignItems={heroPresentation.alignItems} gap={heroPresentation.gap} style={heroContainerStyle}>
          <motion.div style={heroGlowStyle} aria-hidden="true" variants={{
            idle: { opacity: 0.8 },
            hovered: { opacity: 1 },
        }} transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}/>
        <Ctext size={heroPresentation.titleSize} weight={FontWeight.Medium} color={ColorType.White} opacity={1} align={heroPresentation.textAlign} style={heroTitleStyle}>
          Witness AI
        </Ctext>
        <Ctext size={heroPresentation.subtitleSize} weight={FontWeight.Medium} color={ColorType.Accent} opacity={1} align={heroPresentation.textAlign} style={heroSubtitleStyle}>
          Unleashed
        </Ctext>
        </Ccontainer>
      </motion.div>
    );
}
